import { useTranslation } from 'react-i18next'
import { type LoaderFunctionArgs, useLoaderData } from 'react-router'
import { ForgotPasswordEmail } from '#app/components/email/forgot-password.tsx'
import { requireControlsToBeEnabled } from '#app/utils/controls.server.js'
import { getDomainUrl } from '#app/utils/misc.tsx'

export async function loader({ request }: LoaderFunctionArgs) {
  requireControlsToBeEnabled()

  const baseUrl = getDomainUrl(request)

  return { baseUrl }
}

export default function SignupEmailPreviewRoute() {
  const { baseUrl } = useLoaderData<typeof loader>()

  const { t } = useTranslation()
  return (
    <>
      <ForgotPasswordEmail
        firstName="Somebody"
        passwordResetUrl="http://example.com"
        baseUrl={baseUrl}
        t={t}
      />
    </>
  )
}
